import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    totalPrice: null,
    totalPriceFormatted: null,
    itemPrice: null,
    itemPriceFormatted: null,
    totalPackagingPrice: null,
    totalPackagingPriceFormatted: null,
    lines: [],
    cartGroups: [],
    orderDeliveryType: null,
    orderPaymentTypes: [],
    orderPaymentType: null,
    updateCartUrl: null,
    firstname: null,
    lastname: null,
    email: null,
    phone: null,
    address: null,
    note: null,
    errors: {
      firstname: [],
      lastname: [],
      email: [],
      phone: [],
      address: [],
      note: [],
    },
    is_valid: false,
    totalAmount: null,
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
